/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree').is(':checked')) {
        $(this).submit();
      }
      else {
        alert("You must agree with the terms and conditions of sales to check out.");
        return false;
      }
    });
  $('.Reload').on('click',function(){
  	setTimeout(function(){ location.reload(); }, 1000);
  });
  
	waitForElement();


  });

 function waitForElement(){
   var discount = $(".reduction-code__text")[0];

    if(typeof discount !== "undefined"){
        //variable exists, do what you want
                  


      if(discount.innerText == "WHOLESALEBIRD"){
            console.log(discount);
        $('.total-line--shipping').attr('style','display:none;');
        	waitForShipping();
      }else{
                  	$('.section--payment-method').addClass('retail');
    	}
      
    }
    else{
        setTimeout(waitForElement, 1000);


    }
}

function waitForShipping(){
	var payment = $(".section--payment-method .radio__label__primary")[0];

    if(typeof payment !== "undefined"){
        //variable exists, do what you want

            console.log(payment);
              	$('.section--payment-method').addClass('wholesale');
      			$('.section.section--payment-method.wholesale .radio-wrapper[data-gateway-name="paypal"]').style('display','none');
      
      
    }
    else{
        setTimeout(waitForShipping, 1000);
        	console.log("ship wait");


    }
}


$(window).on('load', function() {
    // your code here


});